import {SchemaGradeDefinitionModel} from '@app/views/admin/application-settings/models/schema-grade-definition.model';
import {DictionaryEntryModel} from '@app/views/admin/application-settings/models/dictionary-entry-model';

export class DictionaryModel {
    constructor(
        public dictionaryId: number = null,
        public dictionaryName: string = '',
        public orgId: string = null,
        public multiple: boolean = null,
        public externalPropertyDescriptions: SchemaGradeDefinitionModel[] = [],
        public edutonePropertyDescriptions: SchemaGradeDefinitionModel[] = [],
        public entries: DictionaryEntryModel[] = []
    ) { }
}

export const GRADE_DICTIONARY_NAME = 'Grade';
export const AMPLIFY_STAFF_ACCESS_DICTIONARY_NAME = 'AmplifyStaffAccess';
export const QWIKLABS_ACTIVATED_COURSES_DICTIONARY_NAME = 'QwiklabsActivatedCoursesForSchools';
export const QWIKLABS_COURSE_MAPPING_DICTIONARY_NAME = 'QwiklabsCourseMapping';
export const AMPLIFY_ORG_MAPPING_DICTIONARY_NAME = 'AmplifyOrganizationOrgMapping';
export const SSO_APPLICATIONS_DICTIONARY_NAME = 'ClassRoomStaticSSOLinks';
export const COURSERA_COURSES_DICTIONARY_NAME = 'CourseraCourseMapping';
